import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { HomeDpPositions, DP_PAGE, HotOffer } from '@/types/home-newest';
import { getMultiLangAttr } from '@/business/home-newest';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { getHomeBiExt } from '@/business/home-bi-helper';

/**
 * 格式化热门优惠数据
 */
function handleHotOfferList(data: DpItem[] = []) {
  const result: HotOffer[] = data.map((item, index) => {
    const { url, title, img, time, appid, username, path } = item.contentBaseData as any;
    return {
      url,
      title: getMultiLangAttr(title),
      img: getMultiLangAttr(img),
      id: item.dpId,
      startTime: new Date(time.startTime),
      endTime: new Date(time.endTime),
      // 时间展示类型
      descTimeType: time.type,
      reportInfo: getHomeBiExt(item, {
        fbanner_no: `${index + 1}`,
        fdp_hkdesc: title.hk,
      }),
      // 小程序相关配置
      appid,
      username,
      path,
    };
  });
  return result;
}

/**
 * 获取热门优惠数据
 */
export async function getHotOfferList() {
  const dpMessageRes = await queryDpMessage({
    dpPage: DP_PAGE,
    dpPositions: [HomeDpPositions.HotOffer],
  });
  return handleHotOfferList(dpMessageRes?.dpList);
}
